import React, { useEffect, useState } from 'react';
import { serverAddress } from '../../config';
import { Global_Data } from "../../globalData/GlobalData";
import axios from 'axios';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import { vsprintf } from 'sprintf-js';
import { Checkbox } from "@mui/material";
import ComponentLoadingBoundary from "../Loading/ComponentLoadingBoundary";
import usePendingRequests from "../Loading/usePendingRequests";

const RenderTreeComponent = ({ data, setTextValue, freeFormTabbleEditMainrecord }) => {

    const { token } = Global_Data();
    const [treeLevelsData, setTreeLevelsData] = useState();
    const [checkedItems, setCheckedItems] = useState([]);
    const [indexesDataSet, setIndexesDataSet] = useState([]);
    const { loading, trackRequest } = usePendingRequests();

    function replaceURIParams(data, uri) {
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            const regex = new RegExp(`{${key}}`, "g");
            uri = uri.replace(regex, data[key]);
          }
        }
        return uri;
    }

    async function fetchTreeLevelsData() {
        if(data?.data?.sAction == "CASCADE" && freeFormTabbleEditMainrecord){
            const URI = replaceURIParams(freeFormTabbleEditMainrecord, data?.data?.sDataSource);
            if(!URI.includes("{") && !URI.includes("}")){
                try {
                    const response = await trackRequest(() =>
                        axios.get(`${serverAddress}${URI}`, {
                            headers: {
                                Authorization: `Bearer ${token}`
                            }
                        })
                    );
                    setTreeLevelsData(response);
                } catch (error) {
                    console.log("Error", error.message);
                }
            }
        } else {
            try {
                const response = await trackRequest(() =>
                    axios.get(`${serverAddress}${data?.data?.sDataSource}`, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    })
                );
                setTreeLevelsData(response);
            } catch (error) {
                console.log("Error", error.message);
            }
        }
    }

    useEffect(() => {
        if (data) {
            fetchTreeLevelsData();
        }
    }, [data, freeFormTabbleEditMainrecord])

    function replacePlaceholders(uri, data) {
        const regex = /{([^}]+)}/g;
        const replacedUri = uri?.replace(regex, (match, key) => {
            return key in (data || {}) ? data[key] : match;
        });
        return replacedUri;
    }

    function collectCheckedItems(levelData, levelNumber, checkedItems = [], indexDataset = [], itemId = "") {
        if (!levelData) return checkedItems;
    
        const levelStructuralData = data?.component?.sLevels[`level${levelNumber}`];
    
        levelData.forEach((treeLevelItem, index) => {
            const updatedItemId = itemId == "" ? `${index}` : `${itemId}-${index}`;
            if(!indexDataset.includes(updatedItemId)){
                indexDataset.push(updatedItemId);
            }
            if (treeLevelItem[levelStructuralData?.sCheckField].trim() === "Yes") {
                if (!checkedItems?.includes(updatedItemId)) {
                    checkedItems.push(updatedItemId);
                }
            }
            if (treeLevelItem?.sDetails?.length > 0) {
                collectCheckedItems(treeLevelItem?.sDetails, levelNumber + 1, checkedItems, indexDataset, updatedItemId);
            }
        });
    
        return { checkedItems, indexDataset };
    }

    function checkItemsLogic(itemId, itemsChecked) {
        if(itemsChecked?.includes(itemId)){
            const updatedItems = checkedItems.filter((item) => item != itemId);
            return updatedItems.filter((item) => !item.startsWith(String(itemId)));
        } else {
            const indexesDatasetValues = indexesDataSet.filter((item) => item.startsWith(String(itemId)));
            const itemIdSplitValues = itemId.split("-");
            const actualParentNodes = itemIdSplitValues.slice(0, itemIdSplitValues.length - 1);
            const combiningParentNodes = [];
            actualParentNodes.forEach((node, index) => {
                combiningParentNodes.push(actualParentNodes.slice(0, index + 1).join("-"));
            });
            return [...checkedItems, ...indexesDatasetValues, ...combiningParentNodes];
        }
    }

    function handleSelectionChange(event) {
        event.stopPropagation();
        const itemId = event.target.id;
        const checkItemsData = checkItemsLogic(itemId, checkedItems);
        setCheckedItems(checkItemsData);
    }

    function RenderTreeLevelItems({ levelData, levelNumber, itemId }) {
        const levelStructuralData = data?.component?.sLevels[`level${levelNumber}`];
        return (
            <>
                {levelData?.map(
                    (treeLevelItem, index) => {
                        const levelDisplayFields = levelStructuralData?.sDisplayField;
                        const substitutedFields = replacePlaceholders(levelDisplayFields, treeLevelItem);
                        const displayValue = vsprintf(levelStructuralData?.sDisplayFormat, substitutedFields?.split(','));
                        const updatedItemId = itemId == "" ? `${index}` : `${itemId}-${index}`;

                        return (
                            <TreeItem
                                key={index}
                                itemId={updatedItemId}
                                name={updatedItemId}
                                id={updatedItemId}
                                label={
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                      <Checkbox checked={checkedItems?.includes(updatedItemId)} id={updatedItemId} onClick={handleSelectionChange} />
                                      <span>{displayValue}</span>
                                    </div>
                                  }
                                marginLeft={20}
                                {...levelStructuralData?.sLabelProps}
                                sx={{
                                    ...levelStructuralData?.sLabelProps?.sx,
                                    "& .MuiTreeItem-content.Mui-selected": { backgroundColor: "transparent !important" },
                                    "& .MuiTreeItem-content.Mui-focused": { backgroundColor: "transparent !important" },
                                }}
                            >
                                {
                                    levelData[index]?.sDetails &&
                                    levelData[index]?.sDetails?.length > 0 &&
                                    <RenderTreeLevelItems
                                        levelData={levelData[index]?.sDetails}
                                        levelNumber={levelNumber + 1}
                                        itemId={updatedItemId}
                                    />
                                }
                            </TreeItem>
                        )
                    }
                )}
            </>
        )
    }

    function returnTreeLevelPayload(levelData, levelNumber, itemId = "") {
        const levelStructuralData = data?.component?.sLevels[`level${levelNumber}`];
        const fields = levelStructuralData?.sSendFields?.split(", ");

        return levelData?.map((level, index) => {
            const updatedItemId = itemId == "" ? `${index}` : `${itemId}-${index}`;
            const payloadTreeLevelData = {};
            fields?.forEach((item) => {
                if(item == "bAllow"){
                    if(checkedItems?.includes(updatedItemId)){
                        payloadTreeLevelData[item] = "Yes";
                    } else {
                        payloadTreeLevelData[item] = "No";
                    }
                } else {
                    payloadTreeLevelData[item] = level?.[item];
                }
            });

            if (level?.sDetails && level?.sDetails?.length > 0) {
                payloadTreeLevelData["sDetails"] = returnTreeLevelPayload(level?.sDetails, levelNumber + 1, updatedItemId);
            }
            return payloadTreeLevelData;
        });
    }

    useEffect(() => {
        if (treeLevelsData) {
            const payloadSubstitutedData = returnTreeLevelPayload(treeLevelsData?.data?.data?.mainrecord, 1);
            setTextValue((prev) => ({ ...prev, [data?.component?.sName]: payloadSubstitutedData }))
        }
    }, [data, treeLevelsData, checkedItems])

    useEffect(() => {
        if (treeLevelsData) {
          const { checkedItems, indexDataset } = collectCheckedItems(
            treeLevelsData?.data?.data?.mainrecord,
            1
          );
          setCheckedItems(checkedItems);
          setIndexesDataSet(indexDataset);
        }
    }, [treeLevelsData]);

    return (
        <ComponentLoadingBoundary
            loading={loading}
            label={`Loading ${data?.component?.sName}`}
            minHeight={80}
            size={24}
        >
            <SimpleTreeView multiSelect>
                <RenderTreeLevelItems
                    levelData={treeLevelsData?.data?.data?.mainrecord}
                    levelNumber={1}
                    itemId=""
                />
            </SimpleTreeView>
        </ComponentLoadingBoundary>
    )
}

export default RenderTreeComponent;
